module.exports = __webpack_public_path__ + "img/main-2.8d7a3939.png";